import { IApplicationState } from '../../types/redux';

export const selectMaterialsFilter = (state: IApplicationState) => {
  return state.filters.savedFilters.materials || [];
};
